import Cookies from 'js-cookie'

// 获取用户信息（从 sessionStorage）
export function getUserInfo() {
  const userInfo = sessionStorage.getItem('userInfo')
  if (userInfo) {
    try {
      return JSON.parse(userInfo)
    } catch (e) {
      // console.error('解析用户信息失败', e)
      return null
    }
  }
  return null
}

// 获取用户对象
export function getUser() {
  return getUserInfo() && getUserInfo().user
}

// 获取 Token（会话 cookie，关闭浏览器自动清除）
export function getToken() {
  return Cookies.get('token')
}

// 设置 Token（会话 cookie）
export function setToken(token) {
  // 不设置 expires，默认为会话 cookie，关闭浏览器后自动清除
  return Cookies.set('token', token)
}

// 移除 Token
export function removeToken() {
  return Cookies.remove('token')
}

// 获取用户名
export function getUsername() {
  try {
    return JSON.parse(sessionStorage.getItem('username'))
  } catch (e) {
    return null
  }
}

// 检查是否登录
export function isLoggedIn() {
  return sessionStorage.getItem('isLogin') === 'true'
}

// 设置登录状态
export function setLoginStatus(isLogin) {
  sessionStorage.setItem('isLogin', isLogin ? 'true' : 'false')
}

// 清除所有用户信息（包括 sessionStorage 和 cookie）
export function clearUserInfo() {
  removeToken()
  sessionStorage.removeItem('userInfo')
  sessionStorage.removeItem('username')
  sessionStorage.removeItem('isLogin')
}

// 移除用户信息（保留 token）
export function removeUserInfo() {
  sessionStorage.removeItem('userInfo')
}

// 设置用户信息
export function setUserInfo(userInfo) {
  if (userInfo) {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    if (userInfo.user && userInfo.user.userName) {
      sessionStorage.setItem('username', JSON.stringify(userInfo.user.userName))
    }
  }
}
